<template>
    <v-layout justify-center>
        <v-responsive width="100%">
            <list-heading v-bind="{ title }" showsPrevButton class="mt-n3 mb-1" @prev="$router.go(-1)">
                <template #buttons>
                    <statistics-common-filter v-model="searchDateValue" v-bind="{ loading }" @input="updatedCount = 0" />
                </template>
            </list-heading>

            <v-row class="ma-n2">
                <v-col class="pa-2" cols="12">
                    <statistics-recruitment-applications
                        v-bind="{
                            _recruitment,
                            searchDateValue,
                            loading,
                        }"
                        v-on="{
                            updated,
                        }"
                    />
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-row class="ma-n2" align="stretch">
                        <v-col class="pa-2" cols="12" md="6" lg="3">
                            <statistics-recruitment-workexperience
                                v-bind="{
                                    _recruitment,
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12" md="6" lg="3">
                            <statistics-recruitment-languages
                                v-bind="{
                                    _recruitment,
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12" md="6" lg="3">
                            <statistics-recruitment-certification
                                v-bind="{
                                    _recruitment,
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12" md="6" lg="3">
                            <statistics-recruitment-residence
                                v-bind="{
                                    _recruitment,
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import StatisticsCommonFilter from "@/components/console/statistics/common/statistics-common-filter.vue";
import StatisticsRecruitmentApplications from "@/components/console/statistics/recruitment/statistics-recruitment-applications.vue";
import StatisticsRecruitmentCertification from "@/components/console/statistics/recruitment/statistics-recruitment-certification.vue";
import StatisticsRecruitmentConsequences from "@/components/console/statistics/recruitment/statistics-recruitment-consequences.vue";
import StatisticsRecruitmentLanguages from "@/components/console/statistics/recruitment/statistics-recruitment-languages.vue";
import StatisticsRecruitmentRecruitments from "@/components/console/statistics/recruitment/statistics-recruitment-recruitments.vue";
import StatisticsRecruitmentResidence from "@/components/console/statistics/recruitment/statistics-recruitment-residence.vue";
import StatisticsRecruitmentWorkexperience from "@/components/console/statistics/recruitment/statistics-recruitment-workexperience.vue";
import { initRecruitment } from "@/assets/variables";
import api from "@/api";

export default {
    components: {
        ListHeading,
        StatisticsCommonFilter,
        StatisticsRecruitmentApplications,
        StatisticsRecruitmentCertification,
        StatisticsRecruitmentConsequences,
        StatisticsRecruitmentLanguages,
        StatisticsRecruitmentRecruitments,
        StatisticsRecruitmentResidence,
        StatisticsRecruitmentWorkexperience,
    },
    props: {
        _recruitment: { type: String, default: null },
    },
    data: () => ({
        recruitment: undefined,

        searchDateValue: [
            //
            dayjs().subtract(1, "month").add(1, "day").startOf("day").toISOString(),
            dayjs().endOf("day").toISOString(),
        ],

        updatedCount: 0,
    }),
    computed: {
        title() {
            let title = "채용공고 통계";
            if (this.recruitment) title += ` - "${this.recruitment.subject}"`;
            return title;
        },
        loading() {
            return !!this.recruitment && this.updatedCount < 5;
        },
    },
    methods: {
        async init() {
            const { recruitment } = await api.console.recruitments.get({ _id: this._recruitment });
            this.recruitment = recruitment;
        },
        updated() {
            this.updatedCount += 1;
        },
    },
    watch: {
        _recruitment() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    th,
    td {
        border-color: var(--v-content-base) !important;
    }
}
</style>